import React, {
  useEffect,
  useRef,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Settings } from '@folio/stripes/smart-components';
import {
  stripesShape,
  stripesConnect,
  TitleManager,
} from '@folio/stripes/core';
import { SettingsLabel } from '@folio/stripes-data-transfer-components';
import { Callout } from '@folio/stripes/components';

import PropTypes from 'prop-types';
import { MappingProfilesContainer } from '../MappingProfiles/MappingProfilesContainer';
import { JobProfilesContainer } from '../JobProfiles/JobProfilesContainer';
import { StorageSettings } from '../StorageSettings';
import { CalloutContext } from '../../contexts/CalloutContext';
import { ProfilesLabel } from './ProfilesLabel/ProfilesLabel';

const getSettingsLabel = (messageId, iconKey) => {
  return (
    <SettingsLabel
      messageId={`ui-data-export.${messageId}`}
      iconKey={iconKey}
    />
  );
};



export function DataExportSettings(props) {
  const calloutRef = useRef(null);
  const paneTitleRef = useRef(null);
  const intl = useIntl();

  const sections = [
    {
      label:
  <TitleManager page={intl.formatMessage({ id: 'ui-data-export.settings.index.managerTitle' })}>
    <ProfilesLabel />
  </TitleManager>,
      pages: [
        {
          route: 'job-profiles',
          label: getSettingsLabel('jobProfilesTitle', 'jobProfiles'),
          component: stripesConnect(JobProfilesContainer),
        },
        {
          route: 'mapping-profiles',
          label: getSettingsLabel('mappingProfilesTitle', 'mappingProfiles'),
          component: stripesConnect(MappingProfilesContainer),
        },
      ],
    },
    {
      label: getSettingsLabel('settings.storage.sectionLabel', 'settings'),
      pages: [
        {
          route: 'storage',
          label: getSettingsLabel('settings.storage.title', 'settings'),
          component: StorageSettings,
        },
      ],
    },
  ];

  useEffect(() => {
    if (paneTitleRef.current) {
      paneTitleRef.current.focus();
    }
  }, []);

  return (
    <>
      <CalloutContext.Provider value={calloutRef.current}>
        <Settings
          {...props}
          navPaneWidth="15%"
          sections={sections}
          paneTitle={<FormattedMessage id="ui-data-export.settings.index.paneTitle" />}
          paneTitleRef={paneTitleRef}
        />
      </CalloutContext.Provider>
      <Callout ref={calloutRef} />
    </>
  );
}

DataExportSettings.propTypes = { stripes: stripesShape.isRequired, location: PropTypes.object };
